"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _alloyReactTheme = _interopRequireDefault(require("@adsk/alloy-react-theme"));
var _alloyReactDivider = _interopRequireDefault(require("@adsk/alloy-react-divider"));
var _i18n = require("../../../i18n");
var _OptionalComponents = _interopRequireWildcard(require("../../OptionalComponents"));
var _QuickReportsPanelContext = _interopRequireDefault(require("../QuickReportsPanelContext"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const OptionalComponentsSelection = _ref => {
  let {
    fields = [],
    onChange,
    customSubtext,
    format,
    reportType
  } = _ref;
  const {
    T
  } = (0, _i18n.useTranslation)();
  const [showComponent, setShowComponent] = (0, _react.useState)(true);
  const [resetFields, setResetFields] = (0, _react.useState)(false);
  const {
    onCustomizeComponents
  } = (0, _react.useContext)(_QuickReportsPanelContext.default);
  const filteredFields = (0, _OptionalComponents.filterComponentsByFormat)({
    components: fields,
    format
  });
  (0, _react.useEffect)(() => {
    setShowComponent(filteredFields.length > 0);
    setResetFields(!resetFields);
  }, [format, reportType]);
  if ((0, _OptionalComponents.isLoading)(fields)) {
    const key = fields.reduce((result, _ref2) => {
      let {
        field
      } = _ref2;
      return result += field;
    }, '');
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, showComponent && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_alloyReactDivider.default, null), /*#__PURE__*/_react.default.createElement(Title, null, T.translate('form.label.components')), /*#__PURE__*/_react.default.createElement(_OptionalComponents.default, {
      key: key,
      onChange: onChange,
      fields: filteredFields,
      onCustomizeComponents: onCustomizeComponents,
      customSubtext: customSubtext,
      resetFields: resetFields
    })));
  } else {
    return null;
  }
};
const Title = _styledComponents.default.div`
  ${{
  ..._alloyReactTheme.default.typography.labelMedium
}}
  color: #3C3C3C;
  font-size: 14px;
  margin-top: 0.7em;
`;
OptionalComponentsSelection.propTypes = {
  fields: _propTypes.default.array,
  customSubtext: _propTypes.default.string,
  options: _propTypes.default.array,
  onChange: _propTypes.default.func.isRequired,
  format: _propTypes.default.string.isRequired,
  reportType: _propTypes.default.string.isRequired
};
var _default = exports.default = OptionalComponentsSelection;